'use strict';

angular.module('imagetrend.components')
    .controller('hlpLongevityCreditsApprovalController', ['$scope', 'ServiceUserLongevities', 'Users', '$q', '$timeout', function ($scope, ServiceUserLongevities, Users, $q, $timeout) {

        $scope.service_users = [];
        $scope.serviceUserLongevities = {};
        $scope.loading = true;
        $scope.check_all = false;

        if ($scope.pdf && $scope.component.elementAnswer.length > 0) {
            $scope.loading = false;
        }
        else {
            $scope.component.elementAnswer = [];
            var promises = [];

            if ($scope.parameters != null && $scope.parameters.service_id != null && $scope.parameters.license_request_id != null) {
                promises.push(Users.get({ service_id: $scope.parameters.service_id, inactiveServiceUsers: true, longevityGet: true}).then(function (serviceUsers) {
                    $scope.service_users = serviceUsers;
                    $scope.service_users = $scope.service_users.map(function (user) {
                        user.approved = false;
                        return user;
                    })
                }))

                promises.push(ServiceUserLongevities.get({ license_request_id: $scope.parameters.license_request_id }).then(function (serviceUserLongevities) {
                    if (serviceUserLongevities != null) {
                        serviceUserLongevities.forEach(function (sul) {
                            if (sul.service_id == $scope.parameters.service_id && sul.user_id != null) {
                                $scope.serviceUserLongevities[sul.user_id] = sul;
                            }
                        })
                    }
                }))
            }

            $q.all(promises).then(function () {
                $scope.component.elementAnswer = $scope.service_users.map(function (user) {
                    var answer = { service_id: $scope.parameters.service_id, user_id: user.id, license_request_id: $scope.parameters.license_request_id, nameandnumber: user.nameandnumber};
                    if ($scope.serviceUserLongevities[user.id] != null) {
                        answer.approve = true;
                    }
                    return answer;
                });

                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });
        }

        $scope.checkAll = function (check_all) {
            $scope.component.elementAnswer = $scope.component.elementAnswer.map(function (answer) {
                answer.approve = check_all;
                return answer;
            })
        }
    }])
    .directive('hlpLongevityCreditsApproval', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/longevity-credits-approval/longevity-credits-approval.html',
            replace: true,
            controller: 'hlpLongevityCreditsApprovalController',
            scope: {
                parameters: '=?',
                component: '=?',
                pdf: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;